import type { IconProps } from "./icon-types";

/**
 * 한 단계 뒤로(step-back). DataReview의 "0.1초 뒤로" 같은 미세 이동에 사용한다.
 *
 * Lucide의 `step-back` geometry를 정적 SVG로 인라인 재현한다. 진행 방향의 목적지에
 * 경계 막대를 두는 `SkipToStartIcon`(|←)과 달리, step 기준 막대를 뒤쪽에 둬(◁|)
 * "처음으로"와 "한 단계"를 구분한다. 외부 아이콘 runtime dependency는 추가하지 않는다
 * (RFC-design-system-split §아이콘).
 */
export const StepBackwardIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M13.971 4.285A2 2 0 0 1 17 6v12a2 2 0 0 1-3.029 1.715l-9.997-5.998a2 2 0 0 1-.003-3.432z" />
    <path d="M21 20V4" />
  </svg>
);
